import { render, staticRenderFns } from "./RankingAsistencias.vue?vue&type=template&id=5f007678&"
import script from "./RankingAsistencias.vue?vue&type=script&lang=js&"
export * from "./RankingAsistencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports